// src/components/user-generated-content-container/user-generated-content-container.tsx
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment UserGeneratedContentExperienceScoreRatingFragment on ExperienceScoreRating {\n    __typename\n    primary\n    secondary\n    supportingMessages\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  query UserGeneratedContentContainerQuery($context: ContextInput!, $productIdentifier: ProductIdentifierInput!) {\n    experienceScoreInfo(context: $context, productIdentifier: $productIdentifier) {\n      __typename\n      primary {\n        __typename\n        experienceScoreRating {\n          ...UserGeneratedContentExperienceScoreRatingFragment\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
import React2 from "react";
import { gql as gql2, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// src/components/user-generated-content-container/__private/__fragments/user-generated-content-experience-score-rating.tsx
import React from "react";
import { gql } from "@apollo/client";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading, UitkText } from "uitk-react-text";
var fragment = gql(_templateObject());
var UserGeneratedContentExperienceScoreRating = function (param) {
  var data = param.data;
  var primary = data.primary,
    secondary = data.secondary,
    supportingMessages = data.supportingMessages;
  var paddingWithElements = {
    blockend: "two"
  };
  var secondaryMessage = /* @__PURE__ */React.createElement(React.Fragment, null, secondary ? /* @__PURE__ */React.createElement(UitkHeading, {
    tag: "h4",
    size: 7
  }, secondary) : null);
  var renderSupportingMessage = /* @__PURE__ */React.createElement(React.Fragment, null, supportingMessages === null || supportingMessages === void 0 ? void 0 : supportingMessages.map(function (supportingMessage, index) {
    return /* @__PURE__ */React.createElement(UitkSpacing, {
      padding: paddingWithElements,
      key: index + supportingMessage
    }, /* @__PURE__ */React.createElement(UitkText, {
      weight: "regular"
    }, supportingMessage));
  }));
  var displayReviewContent = function () {
    return /* @__PURE__ */React.createElement(Experiment, {
      name: "PDP_MODULARISED_LOCATION_SECTION"
    }, /* @__PURE__ */React.createElement(ExperimentControl, null, secondaryMessage, renderSupportingMessage), /* @__PURE__ */React.createElement(ExperimentVariant, {
      bucket: 1
    }, /* @__PURE__ */React.createElement(UitkLayoutFlex, {
      space: "two"
    }, /* @__PURE__ */React.createElement(UitkLayoutFlexItem, null, secondaryMessage), /* @__PURE__ */React.createElement(UitkLayoutFlexItem, null, renderSupportingMessage))), /* @__PURE__ */React.createElement(ExperimentVariant, {
      bucket: 2
    }, /* @__PURE__ */React.createElement(UitkLayoutFlex, {
      space: "two"
    }, /* @__PURE__ */React.createElement(UitkLayoutFlexItem, null, secondaryMessage), /* @__PURE__ */React.createElement(UitkLayoutFlexItem, null, renderSupportingMessage))));
  };
  return /* @__PURE__ */React.createElement(React.Fragment, null, primary ? /* @__PURE__ */React.createElement(UitkSpacing, {
    padding: paddingWithElements
  }, /* @__PURE__ */React.createElement(UitkHeading, {
    tag: "h3",
    size: 5
  }, primary)) : null, displayReviewContent());
};
UserGeneratedContentExperienceScoreRating.fragment = fragment;
UserGeneratedContentExperienceScoreRating.displayName = "UserGeneratedContentExperienceScoreRating";
// src/components/user-generated-content-container/user-generated-content-container.tsx
var __Query = gql2(_templateObject1(), UserGeneratedContentExperienceScoreRating.fragment);
var UserGeneratedContentContainer = function (props) {
  var inputs = props.inputs,
    skipSsr = props.skipSsr,
    batchKey = props.batchKey;
  var context = useBexApi().context;
  var DEFAULT_BATCH_KEY = "default-product-details-experience-batch-key";
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      context: {
        batchKey: batchKey !== null && batchKey !== void 0 ? batchKey : DEFAULT_BATCH_KEY
      },
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  if (loading || error || !data || !data.experienceScoreInfo) {
    return null;
  }
  var primary = data.experienceScoreInfo.primary;
  return /* @__PURE__ */React2.createElement("div", {
    "data-stid": "user-generated-content"
  }, (primary === null || primary === void 0 ? void 0 : primary.experienceScoreRating) && /* @__PURE__ */React2.createElement(UserGeneratedContentExperienceScoreRating, {
    data: primary.experienceScoreRating
  }));
};
UserGeneratedContentContainer.displayName = "sharedui-UserGeneratedContentContainer";
// src/__generated__/types.ts
var IdentifierType = /* @__PURE__ */function (IdentifierType2) {
  IdentifierType2["ACTIVITY_ID"] = "ACTIVITY_ID";
  IdentifierType2["CART_ID"] = "CART_ID";
  IdentifierType2["CHECKOUT_SESSION_ID"] = "CHECKOUT_SESSION_ID";
  IdentifierType2["ENTITY_ID"] = "ENTITY_ID";
  IdentifierType2["LEGACY_ORDER_ID"] = "LEGACY_ORDER_ID";
  IdentifierType2["OFFER_ID"] = "OFFER_ID";
  IdentifierType2["ORDER_ID"] = "ORDER_ID";
  IdentifierType2["PROPERTY_ID"] = "PROPERTY_ID";
  IdentifierType2["SAILING_TOKEN"] = "SAILING_TOKEN";
  return IdentifierType2;
}(IdentifierType || {});
export { IdentifierType, UserGeneratedContentContainer };